// @ts-nocheck

export const localeCodes =  [
  "DK",
  "DU",
  "EN",
  "ES",
  "FI",
  "FR",
  "HU",
  "NL",
  "PL",
  "RU",
  "SK"
]
export const localeLoaders = {
  DK: [
    {
      key: "locale_dk_46json_957b24a4",
      load: () => import("#nuxt-i18n/957b24a4" /* webpackChunkName: "locale_dk_46json_957b24a4" */),
      cache: true
    }
  ],
  DU: [
    {
      key: "locale_du_46json_43960c39",
      load: () => import("#nuxt-i18n/43960c39" /* webpackChunkName: "locale_du_46json_43960c39" */),
      cache: true
    }
  ],
  EN: [
    {
      key: "locale_en_46json_d5183db7",
      load: () => import("#nuxt-i18n/d5183db7" /* webpackChunkName: "locale_en_46json_d5183db7" */),
      cache: true
    }
  ],
  ES: [
    {
      key: "locale_es_46json_0e5cfd7c",
      load: () => import("#nuxt-i18n/0e5cfd7c" /* webpackChunkName: "locale_es_46json_0e5cfd7c" */),
      cache: true
    }
  ],
  FI: [
    {
      key: "locale_fi_46json_37f4ccee",
      load: () => import("#nuxt-i18n/37f4ccee" /* webpackChunkName: "locale_fi_46json_37f4ccee" */),
      cache: true
    }
  ],
  FR: [
    {
      key: "locale_fr_46json_7e6e13f9",
      load: () => import("#nuxt-i18n/7e6e13f9" /* webpackChunkName: "locale_fr_46json_7e6e13f9" */),
      cache: true
    }
  ],
  HU: [
    {
      key: "locale_hu_46json_c466c4bc",
      load: () => import("#nuxt-i18n/c466c4bc" /* webpackChunkName: "locale_hu_46json_c466c4bc" */),
      cache: true
    }
  ],
  NL: [
    {
      key: "locale_nl_46json_7133ba1e",
      load: () => import("#nuxt-i18n/7133ba1e" /* webpackChunkName: "locale_nl_46json_7133ba1e" */),
      cache: true
    }
  ],
  PL: [
    {
      key: "locale_pl_46json_b5b070f8",
      load: () => import("#nuxt-i18n/b5b070f8" /* webpackChunkName: "locale_pl_46json_b5b070f8" */),
      cache: true
    }
  ],
  RU: [
    {
      key: "locale_ru_46json_4ae8e51f",
      load: () => import("#nuxt-i18n/4ae8e51f" /* webpackChunkName: "locale_ru_46json_4ae8e51f" */),
      cache: true
    }
  ],
  SK: [
    {
      key: "locale_sk_46json_ace2d9f4",
      load: () => import("#nuxt-i18n/ace2d9f4" /* webpackChunkName: "locale_sk_46json_ace2d9f4" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/1465a2b0" /* webpackChunkName: "config_i18n_46config_46ts_1465a2b0" */)
]
export const normalizedLocales = [
  {
    code: "DK",
    language: undefined
  },
  {
    code: "DU",
    language: undefined
  },
  {
    code: "EN",
    language: undefined
  },
  {
    code: "ES",
    language: undefined
  },
  {
    code: "FI",
    language: undefined
  },
  {
    code: "FR",
    language: undefined
  },
  {
    code: "HU",
    language: undefined
  },
  {
    code: "NL",
    language: undefined
  },
  {
    code: "PL",
    language: undefined
  },
  {
    code: "RU",
    language: undefined
  },
  {
    code: "SK",
    language: undefined
  }
]

